module.exports = __webpack_public_path__ + "static/img/yz6.5e975f88.png";